module.exports = __webpack_public_path__ + "img/pin-presidente.39fb88b5.png";